const PATH = Object.freeze({
  //Auth
  LOGIN: '/login',
  SIGN_UP: '/sign-up',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  CREATE_PASSWORD: '/create-password',
  CHANGE_PASSWORD: '/change-password',
  VERIFY_EMAIL: '/verify-account',

  //Content
  CONTENT: '/library',
  EXERCISES: 'exercises',
  ADD_EXERCISES: 'add',
  EDIT_EXERCISES: 'edit/:id',
  LESSONS: 'lessons',
  ADD_LESSONS: 'add',
  EDIT_LESSONS: 'edit/:id',
  COURSES: 'courses',
  ADD_COURSES: 'add',
  EDIT_COURSES: 'edit/:id',
  FUNCTIONAL_TESTS: 'functional-test',
  ADD_FUNCTIONAL_TESTS: 'add',
  EDIT_FUNCTIONAL_TESTS: 'edit/:id',
  ASSESSMENTS: 'assessments',
  ADD_ASSESSMENTS: 'add',
  EDIT_ASSESSMENTS: 'edit/:id',

  //Institutions
  INSTITUTIONS: '/institutions',
  ADD_INSTITUTIONS: 'add',
  INSTITUTION_DETAIL: ':institutionId',

  //Admins
  ADMINS: '/admins',
  ADD_ADMIN: 'add',
  EDIT_ADMIN: 'edit/:id',

  //User
  USER: '/user',
  PROFILE: '/profile',
  USERNAME: 'username',
  PASSWORD: 'password',

  //Trainers
  TRAINERS: '/trainers',
  TRAINER_FULL_TIME: 'full-time',
  TRAINER_FULL_TIME_ADD: 'full-time/add',
  TRAINER_FULL_TIME_DETAIL: 'full-time/:id',
  TRAINER_THIRD_PARTY: 'third-party',

  //learners
  LEARNERS: '/clients',
  LEARNER_ADD: 'add',
  LEARNER_EDIT: 'edit/:id',

  //classes
  CLASSES: '/classes',
  CLASSES_ADD: 'add',
  CLASSES_DETAIL: ':id',
  CLASSES_EDIT: 'edit',
  CLASSES_MEMBERS: 'members',
  CLASSES_LESSONS: 'lessons-assessments',
  CLASSES_CALENDAR: 'calendar',
  LEARNER_SCORE: 'client/:id',
  LESSON_DETAIL: 'lesson/:id',
  ASSESSMENT_DETAIL: 'assessment/:id',

  // calendar
  CALENDAR: '/calendar',

  //institution info
  INSTITUTION_INFO: '/institution-info',
  INSTITUTION_GENERAL: 'general',
  INSTITUTION_STATIONS: 'stations',
  INSTITUTION_ANALYTICS: 'analytics',

  //analytics
  ANALYTICS: '/analytics',

  //permission
  PERMISSIONS: '/role-permissions',

  //Error
  ERROR_404: '/error/404',
  ERROR_403: '/error/403',
  ERROR_500: '/error/500',
});

const ListAuthPath = [
  PATH.LOGIN,
  PATH.SIGN_UP,
  PATH.FORGOT_PASSWORD,
  PATH.RESET_PASSWORD,
  PATH.CREATE_PASSWORD,
  PATH.VERIFY_EMAIL,
];

export { PATH, ListAuthPath };
